import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Main from './main';
import Edit from './edit';
import Create from './create';
import SingleService from './single';

const ServicesRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<Main />} />
      <Route path='create' element={<Create />} />
      <Route path=':id/edit' element={<Edit />} />
      <Route path=':id' element={<SingleService />} />
      <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
  );
};

export default ServicesRoutes;